import React from 'react';
import footerImage from './image/footer.svg';
import buttonImage from './image/button.svg';
import './Footer.css';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate('/contact');
  };

  return (
    <div className="footer-container">
      <div className="footer-background">
        <img src={footerImage} alt="Footer Background" />
      </div>
      <div className="footer-content">
        <div className="footer-text">
          <h1>Nashabandhi Mandal Maharashtra Rajya</h1>
          <p>
            218, 2ND Floor, Old Custom House,<br />
            Shaheed Bhagat Singh Road, Fort, Office No. 0223 543  Mumbai - 400001<br />
            Email: <a href="mailto:nashabandimaharajya@gmail.com">nashabandimaharajya@gmail.com</a>
          </p>
          <p>Help Line: 09833394952</p>
        </div>
        <div className="footer-donation">
          <h2>Your Support Matters</h2>
          <button className="support-button-footer" onClick={handleButtonClick}>
            <img src={buttonImage} alt="Support a Cause" />
          </button>
          <p>Click here to make a change</p>
        </div>
      </div>
      <div className="footer-copyright">
        <p>Copyright © Nashabandi Mandal</p>
      </div>
    </div>
  );
};

export default Footer;
